<script setup lang="ts">
const { t } = useEkI18n();
const settingsStore = useSettingsStore();

async function updateUploadNetworkPreference(value: boolean) {
  await settingsStore.set('uploadOnCellular', value);
}
</script>

<template>
  <SettingsToggle
    :checked="settingsStore.settings.uploadOnCellular"
    :label="t('settings.documents.uploadOnCellular')"
    :description="t('settings.documents.uploadOnCellularDescription')"
    @change="updateUploadNetworkPreference"
  />
</template>
